const FOCUSABLE_SELECTOR = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

export function getFocusReturnTarget (doc: Document): HTMLElement | null {
	const activeElement = doc.activeElement;
	const lastMenuTrigger = getLastMenuTrigger(doc);

	if (!(activeElement instanceof HTMLElement)) {
		return lastMenuTrigger;
	}

	if (activeElement.getAttribute('role') === 'menuitem' || activeElement.closest('[role="menu"]') != null) {
		return lastMenuTrigger ?? activeElement;
	}

	return activeElement;
}

export function resolveFocusReturnTarget (
	doc: Document,
	selector: string | undefined,
	fallbackTarget: HTMLElement | null
): HTMLElement | null {
	if (selector != null) {
		const candidate = doc.querySelector(selector);
		if (candidate instanceof HTMLElement) {
			if (candidate.matches(FOCUSABLE_SELECTOR)) {
				return candidate;
			}

			const closestFocusable = candidate.closest(FOCUSABLE_SELECTOR);
			if (closestFocusable instanceof HTMLElement) {
				return closestFocusable;
			}

			const childFocusable = candidate.querySelector(FOCUSABLE_SELECTOR);
			if (childFocusable instanceof HTMLElement) {
				return childFocusable;
			}
		}
	}

	if (fallbackTarget == null || fallbackTarget.isConnected === false) {
		return null;
	}

	return fallbackTarget;
}

export function focusElementWithFallback (element: HTMLElement | null): void {
	if (element == null || element.isConnected === false) {
		return;
	}

	const doc = element.ownerDocument;
	element.focus();
	if (doc?.activeElement === element) {
		return;
	}

	setTimeout(() => {
		if (element.isConnected) {
			element.focus();
		}
	}, 0);
}

function getLastMenuTrigger (doc: Document): HTMLElement | null {
	const element = doc.querySelector('[data-last-menu-trigger="true"]');
	return element instanceof HTMLElement ? element : null;
}
